function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { api } from '@signiapp/helpers';
import { init, saveSigner } from '@signiapp/signature/services/orders';
import { PAGE_SIZE, MODULE_BASE_PATH } from "../scripts/constants";

var req = function req(url, options) {
  return api.req(/^http/.test(url) ? url : "".concat(MODULE_BASE_PATH).concat(url), options);
};

export var createContact = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(contact) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", req('/contacts/create', {
              method: 'POST',
              body: JSON.stringify(contact),
              headers: {
                'Content-Type': 'application/json'
              }
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createContact(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var createContacts = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(contacts) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", req('/contacts/save', {
              method: 'POST',
              body: JSON.stringify(contacts),
              headers: {
                'Content-Type': 'application/json'
              }
            }));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createContacts(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var updateContact = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(contact, language) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", req("/contacts/".concat(contact.id), {
              method: 'PUT',
              body: JSON.stringify({
                contact: contact,
                language: language,
                url: window.SIGNIAPP_FRONTEND_BASE_URL
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function updateContact(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();
export var deleteContact = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", req("/contacts/".concat(id), {
              method: 'DELETE'
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function deleteContact(_x5) {
    return _ref4.apply(this, arguments);
  };
}();
export var deleteContacts = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(ids) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", req("/contacts/delete", {
              method: 'DELETE',
              body: JSON.stringify(ids),
              headers: {
                'Content-Type': 'application/json'
              }
            }));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function deleteContacts(_x6) {
    return _ref5.apply(this, arguments);
  };
}();
export var removeSharedContacts = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(ids) {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            return _context6.abrupt("return", req("/contacts/remove", {
              method: 'POST',
              body: JSON.stringify(ids),
              headers: {
                'Content-Type': 'application/json'
              }
            }));

          case 1:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function removeSharedContacts(_x7) {
    return _ref6.apply(this, arguments);
  };
}();
export var getContacts = /*#__PURE__*/function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(_ref7, url) {
    var currentPage, wildcard, orderBy, orderByDesc, limit, params;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            currentPage = _ref7.currentPage, wildcard = _ref7.wildcard, orderBy = _ref7.orderBy, orderByDesc = _ref7.orderByDesc, limit = _ref7.limit;
            url = url || '/contacts';
            params = new URLSearchParams();
            params.append('limit', limit || PAGE_SIZE);

            if (currentPage > 1) {
              params.append('offset', (currentPage - 1) * PAGE_SIZE);
            }

            if (wildcard) {
              params.append('wildcard', wildcard);
            }

            if (orderBy !== null && orderBy !== undefined) {
              params.append('orderBy', orderBy);
            }

            if (orderByDesc !== null && orderByDesc !== undefined) {
              params.append('orderByDesc', orderByDesc);
            }

            url += '?' + params.toString();
            return _context7.abrupt("return", req(url));

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function getContacts(_x8, _x9) {
    return _ref8.apply(this, arguments);
  };
}();
export var getContact = /*#__PURE__*/function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", req("/contacts/".concat(id)));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));

  return function getContact(_x10) {
    return _ref9.apply(this, arguments);
  };
}();
export var importContacts = /*#__PURE__*/function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(formData) {
    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            return _context9.abrupt("return", req('/contacts/import', {
              method: 'POST',
              body: formData
            }));

          case 1:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));

  return function importContacts(_x11) {
    return _ref10.apply(this, arguments);
  };
}();
export var downloadTemplate = /*#__PURE__*/function () {
  var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            return _context10.abrupt("return", req('/contacts/download'));

          case 1:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));

  return function downloadTemplate() {
    return _ref11.apply(this, arguments);
  };
}();
export var getContactsUsers = /*#__PURE__*/function () {
  var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            return _context11.abrupt("return", req('/contacts/users'));

          case 1:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));

  return function getContactsUsers() {
    return _ref12.apply(this, arguments);
  };
}();
export var getContactSharedUsers = /*#__PURE__*/function () {
  var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            return _context12.abrupt("return", req("/contacts/user/".concat(id)));

          case 1:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));

  return function getContactSharedUsers(_x12) {
    return _ref13.apply(this, arguments);
  };
}();
export var newRequest = /*#__PURE__*/function () {
  var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(contacts, language, signatureMethods) {
    var stack, signers, order;
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            stack = JSON.parse(sessionStorage.getItem('portal.signature.stack'));
            signers = contacts.map(function (c) {
              return {
                firstName: c.firstName,
                lastName: c.lastName,
                email: c.email,
                emailNotification: !!c.email,
                mobile: c.mobileNumber,
                language: language,
                signatureMethods: signatureMethods,
                smsNotification: !!c.mobileNumber,
                companyName: c.companyName,
                companyRole: c.jobTitle,
                required: true
              };
            });
            _context13.next = 4;
            return init(stack, signers);

          case 4:
            order = _context13.sent;
            return _context13.abrupt("return", order);

          case 6:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));

  return function newRequest(_x13, _x14, _x15) {
    return _ref14.apply(this, arguments);
  };
}();
export default {
  createContact: createContact,
  createContacts: createContacts,
  updateContact: updateContact,
  deleteContact: deleteContact,
  deleteContacts: deleteContacts,
  removeSharedContacts: removeSharedContacts,
  getContacts: getContacts,
  getContact: getContact,
  importContacts: importContacts,
  newRequest: newRequest,
  getContactsUsers: getContactsUsers,
  getContactSharedUsers: getContactSharedUsers,
  downloadTemplate: downloadTemplate
};